<span
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.display]="displayCss"
  [style.display]="displayCss">
  @if (isLabelDisplay) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <input
    #input
    autocomplete="off"
    readonly="true"
    type="text"
    [ngClass]="[mandatoryCss, 'input-field p-inputtext']"
    [ngModel]="fieldValue ? fieldValue.displayValue : fieldValue"
    [readonly]="isReadOnly ? 'disabled' : null"
    [tabindex]="isReadOnly ? '-1' : null"
    [value]="suggestionSelected ? suggestionSelected.displayValue : ''"
    (contextmenu)="onContextMenu($event)"
    (focus)="!isReadOnly ? showSuggestions() : null"
    (ngModelChange)="fieldValue ? fieldValue.displayValue : (fieldValue = $event)"
    (press)="onContextMenu($any($event))" />
  <i aria-hidden="true" class="icon fas fa-list" type="button" (click)="changeDisplayPanel()"></i>
</span>

@if (displayPanel) {
  <div class="panel" [style.width.px]="elementRef?.nativeElement.firstElementChild.clientWidth">
    <ng-template iuDynamicContainer />
    <div style="float: right">
      <button class="btnPanel" label="Annuler" pButton type="button" (click)="changeDisplayPanel()"></button>
      <button class="btnPanel" label="Valider" pButton type="button" (click)="validAttributes()"></button>
    </div>
  </div>
}

@if (displaySuggestion && suggestions.length > 0) {
  <div style="position: relative; top: 50px; width: calc(50% - 10px); left: 5px">
    <div
      class="p-autocomplete-panel ui-widget-content ui-corner-all ui-shadow"
      style="max-height: 240px; left: 0; top: 0; width: 100%">
      <ul class="p-autocomplete-items p-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset">
        @for (option of suggestions; track $index) {
          <li
            [ngClass]="['p-autocomplete-list-item ui-corner-all', suggestionSelected === option ? 'p-highlight' : '']"
            (click)="selectItem(option)">
            <span>{{ option.displayValue }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
}
